import { modalClasses } from '@mui/material';

export const EnterKey = 'Enter';
export const EscapeKey = 'Escape';
export const BackspaceKey = 'Backspace';
export const DeleteKey = 'Delete';
export const HomeKey = 'Home';
export const EndKey = 'End';
export const ArrowRightKey = 'ArrowRight';
export const ArrowLeftKey = 'ArrowLeft';

export const isAnyModalOpened = () => {
  return document.querySelectorAll(`.${modalClasses.root}`).length > 0;
}

export const isInputFocused = () => {
  return ['input', 'textarea'].includes((document.activeElement?.tagName || '').toLocaleLowerCase());
}
